// Renderer helpers over the preload contextBridge API. The ElectronAPI shape and
// the Window.electronAPI augmentation live in electron/channels.ts — the single
// source of truth shared with the preload implementation.
import type { ElectronAPI } from '@ipc/channels';

/** The preload-injected API, or undefined when running in a plain browser. */
function electronAPI(): ElectronAPI | undefined {
  return window.electronAPI;
}

/** Write text to the system clipboard — Electron-native in-app, Web Clipboard API in browser dev. */
export async function writeClipboard(text: string): Promise<void> {
  const api = electronAPI();
  if (api) await api.writeClipboard(text);
  else await navigator.clipboard.writeText(text);
}

/** True when running inside Electron (preload bridge present). */
export function isElectron(): boolean {
  return electronAPI() !== undefined;
}

/** Open a URL in the user's default browser (Electron shell) or a new tab in browser dev. */
export async function openExternal(url: string): Promise<void> {
  const api = electronAPI();
  if (api) await api.openExternal(url);
  else window.open(url, '_blank', 'noopener,noreferrer');
}
